import React from 'react';
import classNames from 'classnames';

import {
  COMMUNITY_FACEBOOK_URL,
  COMMUNITY_INSTAGRAM_URL,
  COMMUNITY_X_URL,
  hasHelpChannels,
  hasSocialChannels,
} from '../../config/communityChannels';
import { getHelpChannelLinks } from '../../util/communityChatIntent';

import css from './CommunityChannels.module.css';

const LinkSep = () => <span className={css.sep} aria-hidden>•</span>;

/**
 * Compact escape hatch under app CTAs — one line, text links.
 * @param {string} [text] optional WhatsApp prefill override
 */
export const CommunityAskBar = ({ appId, className, prompt, text }) => {
  const links = getHelpChannelLinks({ appId, text });
  if (!links.length) {
    return null;
  }

  return (
    <div className={classNames(css.askBlock, className)} data-testid="community-ask-bar">
      <p className={css.talkLine}>{prompt || 'Talk with the community'}</p>
      <p className={css.inlineAsk}>
        {links.map((link, i) => (
          <React.Fragment key={link.id}>
            {i > 0 ? <LinkSep /> : null}
            <a
              href={link.href}
              className={css.textLink}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`community-ask-${link.id}`}
            >
              {link.label}
            </a>
          </React.Fragment>
        ))}
      </p>
    </div>
  );
};

/**
 * Landing footer — Talk with the community + WhatsApp · Telegram · X
 */
export const CommunitySocialRow = ({ className, showAsk = true, appId = 'landing' }) => {
  const links = [];
  if (showAsk) {
    links.push(...getHelpChannelLinks({ appId }));
  }
  if (COMMUNITY_X_URL) {
    links.push({ id: 'x', label: 'X', href: COMMUNITY_X_URL });
  }
  if (COMMUNITY_FACEBOOK_URL) {
    links.push({ id: 'facebook', label: 'Facebook', href: COMMUNITY_FACEBOOK_URL });
  }
  if (COMMUNITY_INSTAGRAM_URL) {
    links.push({ id: 'instagram', label: 'Instagram', href: COMMUNITY_INSTAGRAM_URL });
  }

  if (!links.length && !hasHelpChannels() && !hasSocialChannels()) {
    return null;
  }

  if (!links.length) {
    return null;
  }

  return (
    <nav
      className={classNames(css.askBlock, className)}
      aria-label="Community"
      data-testid="community-social-row"
    >
      <p className={css.talkLine}>Talk with the community</p>
      <p className={css.inlineRow}>
        {links.map((link, i) => (
          <React.Fragment key={link.id}>
            {i > 0 ? <LinkSep /> : null}
            <a
              href={link.href}
              className={css.textLink}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`community-social-${link.id}`}
            >
              {link.label}
            </a>
          </React.Fragment>
        ))}
      </p>
    </nav>
  );
};

export default CommunityAskBar;
